import { ItemImageModelDto } from '@treasury/api/channel';
import { DomainEntity } from '@treasury/domain/shared';

export class ItemImageVm extends DomainEntity<ItemImageModelDto> {
    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get frontImage() {
        const prefix = this.dto.frontImage?.startsWith('data:image/jpeg;base64,')
            ? ''
            : 'data:image/jpeg;base64,';
        return this.dto.frontImage ? `${prefix}${this.dto.frontImage}` : '';
    }

    public set frontImage(value: string) {
        this.dto.frontImage = value;
    }

    public get rearImage() {
        const prefix = this.dto.backImage?.startsWith('data:image/jpeg;base64,')
            ? ''
            : 'data:image/jpeg;base64,';
        return this.dto.backImage ? `${prefix}${this.dto.backImage}` : '';
    }

    public set rearImage(value: string) {
        this.dto.backImage = value;
    }

    public get itemReference() {
        return this.dto.itemReference;
    }
}
